/*version*/
function _(require, module, exports) {
    exports.version = '0.12.16';    
}